<template>
  <v-app>
    <!-- <keep-alive> -->
    <component :is="getThemeMode.layout" />
    <!-- </keep-alive> -->

    <!-- <customizer /> -->
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios      from "axios";
import { BASEURL } from "@/api/baseurl";

export default {
  components: {
    Customizer: () => import("@/layouts/common-drawer/Customizer"),
  },
  data() {
    return {
      layoutName: "",
      sessionPollInterval: null,
    };
  },
  computed: {
    ...mapGetters(["getThemeMode"]),
  },
  mounted() {
    // Check session every 30 seconds
    this.sessionPollInterval = setInterval(() => {
      this.validateSession();
    }, 30000); // 30,000ms = 30 seconds
  },
  beforeDestroy() {
    // Clear interval when component is destroyed
    clearInterval(this.sessionPollInterval);
  },
  methods: {
    ...mapActions(["changeThemeLayout"]),
    async validateSession() {
      const token =
        localStorage.getItem("session_token") ||
        sessionStorage.getItem("session_token");

      if (!token) {
        this.forceLogout();
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append("validate_session", "done");
        params.append("token", token);

        const response = await axios.post(`${BASEURL}/user/index.php`,params);

        if (response.data.status !== "1") {
          this.forceLogout();
        }
      } catch (e) {
        console.log("Session check failed", e);
      }
    },

    forceLogout() {
      clearInterval(this.sessionPollInterval);
      localStorage.removeItem("userInfo");
      localStorage.removeItem("session_token");
      sessionStorage.removeItem("session_token");

      // ✅ catch the duplicate navigation error
      this.$router
        .push("/app/sessions/login?reason=session_terminated")
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.log(err);
          }
        });
    },
  },
};
</script>
